import { DocumentStatus } from '@synergy/models';

/**
 * What a portal says about an order: it is ordered, or it is cancelled.
 *
 * Whether an invoice followed, or none did, is POOLALPIN's own bookkeeping. A
 * member read "Beendet ohne Folgebeleg" in red as an alarm on an ordinary order,
 * and a supplier must above all see a cancellation, so as not to deliver it
 * (#2264, #2267).
 */
export const portalOrderStatus = (
    status: DocumentStatus | string
): DocumentStatus.Completed | DocumentStatus.Canceled =>
    DocumentStatus.Canceled === status ? DocumentStatus.Canceled : DocumentStatus.Completed;

export const portalOrderStatusTranslationId = (status: DocumentStatus | string): string =>
    DocumentStatus.Canceled === status ? 'app.documentStatus.canceled' : 'app.portal.orderStatus.ordered';

/**
 * The colour a portal shows for a document's status. "Beendet ohne Folgebeleg"
 * is red in PALO, where it is a task for POOLALPIN; a member reading it on an
 * inquiry of theirs keeps the green it always had (GF 15.10.2026, #2264).
 */
export const portalStatusColor = (status: DocumentStatus): DocumentStatus =>
    DocumentStatus.CompletedWithoutTransition === status ? DocumentStatus.Completed : status;

/** Cancellations a portal still warns about: those of the last `days` days. */
export const isRecentCancellation = (
    order: { status: DocumentStatus | string; updatedAt?: Date | string },
    days = 30,
    now: Date = new Date()
): boolean =>
    DocumentStatus.Canceled === order.status &&
    !!order.updatedAt &&
    now.getTime() - new Date(order.updatedAt).getTime() <= days * 24 * 60 * 60 * 1000;
